
import Vue from 'vue'

export default Vue.extend({
  seo: {
    title: 'Game Boy Emulator | Aaron Cunliffe',
    description: 'A C++ Game Boy emulator project by Aaron Cunliffe, built to explore hardware emulation and preserving video game history.'
  }
})
